import { defineComponent as _defineComponent } from 'vue'
import { queries } from "@/apollo";
import { Release, AppMode } from "@/CodegenTypes";
import { customMoment } from "@/main";
import { useTranslation } from "@/store/translation";
import { useQuery } from "@vue/apollo-composable";
import { first } from "lodash";
import { computed } from "vue";
import { useRoute } from "vue-router/composables";



export default /*#__PURE__*/_defineComponent({
  __name: 'DdResults',
  setup(__props) {

const { result, loading } = useQuery<{ releases: Release[] }>(queries.releasesWithResults, {
  appMode: AppMode.Dd,
  weeksBackCount: 1,
}, { fetchPolicy: 'cache-and-network' })

const route = useRoute()
const { $t } = useTranslation();


const selectedResults = computed(() => {

  const results = selectedRelease.value?.ddResults;

  if (results) {
    return results;
  } else {
    return {
      firstPrize: "-",
      secondPrize: "-",
      thirdPrize: "-",
      starter1: "-",
      starter2: "-",
      starter3: "-",
      starter4: "-",
      starter5: "-",
      starter6: "-",
      starter7: "-",
      starter8: "-",
      starter9: "-",
      starter10: "-",
      consolation1: "-",
      consolation2: "-",
      consolation3: "-",
      consolation4: "-",
      consolation5: "-",
      consolation6: "-",
      consolation7: "-",
      consolation8: "-",
      consolation9: "-",
      consolation10: "-",
    }
  }
})

const selectedRelease = computed(() => {

  const release = result.value?.releases.find(
    (r) => r.releaseDate === selectedStartReleaseDate.value
  );

  // hide if not reports generated
  if (!release?.reportsGenerated) {
    return null;
  }

  return release;
})



const selectedStartReleaseDate = computed(() => {
  const query = route.query.startReleaseDate;
  return Array.isArray(query) ? first(query) : query;
})

function formatDate(date?: Date) {
  if (!date) {
    return "-"
  }
  return customMoment(date).format("ddd, DD MMM YYYY")
}



return { __sfc: true,result, loading, route, $t, selectedResults, selectedRelease, selectedStartReleaseDate, formatDate }
}

})